import { FC, useContext } from 'react';
import Scrollbar from 'src/components/Scrollbar';
import { SidebarContext } from 'src/contexts/SidebarContext';
import { Box, alpha, Divider, useTheme, lighten } from '@mui/material';

import SidebarMenu from './SidebarMenu';
import { SidebarWrapper } from 'src/components/StyledComponents/StudentLayout';

interface Props {
  open: boolean;
  menuClick: () => void;
}

const Sidebar: FC<Props> = (props: Props) => {
  const { open, menuClick } = props;
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();

  return (
    <>
      <SidebarWrapper
        sx={{
          display: {
            display: open ? 'inline-block' : 'none',
            transition: 'visibility 0s, opacity 0.5s linear',
            transitionDelay: '1s'
          },
          position: 'fixed',
          left: 0,
          top: 0,
          background: theme.colors.alpha.trueWhite[100],
          zIndex: 2
        }}
      >
        <Scrollbar>
          <Box mt={3}>
            <Box
              mx={2}
              sx={{
                width: 52
              }}
            ></Box>
          </Box>
          <Divider
            sx={{
              mt: theme.spacing(10),
              mx: theme.spacing(2),
              background: theme.colors.alpha.trueWhite[10]
            }}
          />
          <SidebarMenu handleMenuClick={menuClick} />
        </Scrollbar>
      </SidebarWrapper>
    </>
  );
};

export default Sidebar;
